import { FunctionField } from "react-admin";
import get from "lodash/get";

export const currencyAmount = (amount, currency) =>
  amount.toLocaleString("en-US", {
    style: "currency",
    currency,
  });

export const CurrencyField = ({
  source,
  isCents,
  currencyPath = "currency",
}) => {
  return (
    <FunctionField
      className="CurrencyField"
      render={(record) => {
        let amount = get(record, source);
        if (isCents) {
          amount /= 100;
        }

        const currency = get(record, currencyPath, "USD");

        return currencyAmount(amount, currency);
      }}
    />
  );
};

export const CurrencyCentsField = (props) => (
  <CurrencyField {...props} isCents={true} />
);
